// extracted by mini-css-extract-plugin
module.exports = {"description":"description--YSqn5","editAddress":"editAddress--vNFUO","editIcon":"editIcon--GK7zS"};